if (!customElements.get("m-catalogue-download")) {
  customElements.define(
    "m-catalogue-download",
    class MCatalogueDownload extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          openButton: '[data-open-catalogue]',
          template: '.m-catalogue-download__template'
        };
      }

      connectedCallback() {
        this.sheetUrl = this.dataset.sheetUrl;
        this.pdfUrl = this.dataset.pdfUrl;
        this.colorScheme = this.dataset.colorScheme || '';
        this.templateEl = this.querySelector(this.selectors.template);
        
        if (this.templateEl) {
          this.init();
        }
      }

      init() {
        this.modal = new MinimogTheme.Modal();
        
        // Listen to clicks on the default section button
        const triggerBtn = this.querySelector(this.selectors.openButton);
        if (triggerBtn) {
          triggerBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
          });
        }

        // Setup global listener for other buttons linked to #download-catalogue
        this.setupGlobalListener();
      }

      setupGlobalListener() {
        document.addEventListener('click', (e) => {
          const globalTrigger = e.target.closest('a[href="#download-catalogue"]');
          if (globalTrigger) {
            e.preventDefault();
            this.openModal();
          }
        });
      }

      openModal() {
        const html = document.createElement("DIV");
        html.innerHTML = this.templateEl.innerHTML;
        this.modal.appendChild(html);
        this.modal.setWidth('500px');
        this.modal.setSizes(`m-catalogue-modal-wrapper m-gradient ${this.colorScheme}`);
        this.modal.open();

        // Bind events inside the newly generated modal DOM
        const modalEl = document.querySelector('.m-catalogue-modal-content');
        if (modalEl) {
          const form = modalEl.querySelector('.m-catalogue-modal-form');
          if (form) {
            const mobileInput = form.querySelector('input[name="mobile"]');
            if (mobileInput) {
              mobileInput.addEventListener('input', (e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              });
            }

            form.addEventListener('submit', (e) => {
              e.preventDefault();
              this.handleSubmit(form);
            });
          }
        }
      }

      async handleSubmit(form) {
        const nameInput = form.querySelector('input[name="name"]');
        const mobileInput = form.querySelector('input[name="mobile"]');
        const submitBtn = form.querySelector('.m-catalogue-submit-btn');
        const btnText = form.querySelector('.m-catalogue-btn-text');
        const spinner = form.querySelector('.m-catalogue-spinner');
        const errorMsg = form.querySelector('.m-catalogue-error-message');

        const name = nameInput.value.trim();
        const mobile = mobileInput.value.trim();

        if (!name || !mobile) {
          if (errorMsg) {
            errorMsg.textContent = 'Please fill out all required fields.';
            errorMsg.classList.remove('m-hidden');
          }
          return;
        }

        // Exactly 10-digit number validation
        if (!/^\d{10}$/.test(mobile)) {
          if (errorMsg) {
            errorMsg.textContent = 'Please enter a valid 10-digit mobile number.';
            errorMsg.classList.remove('m-hidden');
          }
          return;
        }

        if (errorMsg) errorMsg.classList.add('m-hidden');
        if (submitBtn) submitBtn.disabled = true;
        if (btnText) btnText.classList.add('m-hidden');
        if (spinner) spinner.classList.remove('m-hidden');

        const params = new URLSearchParams();
        params.append('name', name);
        params.append('mobile', mobile);

        try {
          if (this.sheetUrl) {
            // mode: 'no-cors' allows sending data to Google Apps Script Web App without CORS errors.
            await fetch(this.sheetUrl, {
              method: 'POST',
              mode: 'no-cors',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: params.toString()
            });
          } else {
            console.warn('Google Sheet Apps Script URL is not set in Shopify section settings.');
          }

          // Transition the modal UI to success/download state
          const modalWrapper = form.closest('.m-catalogue-modal-content');
          if (modalWrapper) {
            const formWrapper = modalWrapper.querySelector('.m-catalogue-modal-form-wrapper');
            const successWrapper = modalWrapper.querySelector('.m-catalogue-modal-success-wrapper');
            if (formWrapper && successWrapper) {
              formWrapper.classList.add('m-hidden');
              successWrapper.classList.remove('m-hidden');
            }
          }

        } catch (err) {
          console.error('Error submitting form to sheet:', err);
          if (errorMsg) {
            errorMsg.textContent = 'Something went wrong. Please try again.';
            errorMsg.classList.remove('m-hidden');
          }
          if (submitBtn) submitBtn.disabled = false;
          if (btnText) btnText.classList.remove('m-hidden');
          if (spinner) spinner.classList.add('m-hidden');
        }
      }
    }
  );
}
